import { Badge, BadgeVariants } from "@kamae-apps/shared/Components/Atoms/Badge/Badge"
import { IconButton } from "@kamae-apps/shared/Components/Atoms/IconButton/IconButton"
import { Link } from "@kamae-apps/shared/Components/Atoms/Link/Link"
import { FC, ReactNode } from "react"
import style from "./Toast.module.css"

export type ToastVariant = "toast-success" | "toast-info" | "toast-error" | "toast-warning"

const badgeVariantToast: Record<ToastVariant, BadgeVariants> = Object.freeze({
  "toast-error": "badge-small-error",
  "toast-info": "badge-small-information",
  "toast-success": "badge-small-success",
  "toast-warning": "badge-small-warning",
})

type ToastProps = {
  variant: ToastVariant
  message: string
  closeButton?: boolean
  linkTitle?: string
  onClickLink?: () => void
}

export const Toast: FC<ToastProps> = ({ variant, message, closeButton = false, linkTitle, onClickLink }) => {
  return (
    <div className={style["toast-container"]}>
      <div className={style["toast-content"]}>
        <div className={style["toast-badge"]}>
          <Badge variant={badgeVariantToast[variant]} />
        </div>
        <div className={style["toast-content-message"]}>
          <p>{message}</p>
          {linkTitle && (
            <Link
              variant={"link-default-initial"}
              title={linkTitle}
              onClick={onClickLink}
            />
          )}
        </div>
        {closeButton && (
          <div>
            <IconButton
              variant={"button-small-light"}
              icon={"cross"}
            />
          </div>
        )}
      </div>
      <div
        className={style["toast-progressbar"]}
        data-variant={[variant]}
      >
        <div className={style["toast-progressbar-loading"]} />
      </div>
    </div>
  )
}
